import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { ColorsProvider } from './colors.provider';
import { COLORS, DEFAULT_BORDER_RADIOS } from './main-app.theme';

/**
 * Tema do site.
 *
 * Deliberadamente enxuto. O site ainda não tem tipografia nem componente
 * próprio para sobrescrever, e copiar os overrides do forms criaria uma
 * segunda cópia para manter em sincronia. O que ele precisa hoje é o fundo da
 * marca e o COLORS exposto pelo useTheme para as telas que vierem.
 */
const SITE_THEME = createTheme({
  palette: {
    background: {
      default: COLORS.primary.main,
    },
    primary: {
      main: COLORS.primary.main,
    },
  },
});

const SiteTheme: FC<PropsWithChildren> = ({ children }) => (
  <ThemeProvider theme={SITE_THEME}>
    <CssBaseline />
    <ColorsProvider colors={COLORS} borderRadiusDefault={DEFAULT_BORDER_RADIOS}>
      {children}
    </ColorsProvider>
  </ThemeProvider>
);

export { SiteTheme };
